import * as tslib_1 from "tslib";
import FavoriteNode from './FavoriteNode';
import datapoints from '../datapoints';
import { observer } from 'mobx-react';
import { logMountingPerformance } from 'owa-analytics';
import { logUsage } from 'owa-analytics';
import { getStore as getSharedFavoritesStore } from 'owa-favorites';
import { getStore as getMailFavoritesStore } from 'owa-mail-favorites-store';
import { FavoritesPicker } from 'owa-mail-favorites-picker';
import { showFindFavoritesPicker } from 'owa-mail-favorites-store';
import { FavoriteNodeContextMenu } from 'owa-mail-favorites-view';
import { hideFavoritesContextMenu } from 'owa-mail-favorites-store/lib/actions/favoritesContextMenu';
import strings from 'owa-strings/owa-mail-strings';
import TreeNode from 'owa-tree-node/lib/components/TreeNode';
import * as React from 'react';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import FavoriteNodeV2 from './roaming/FavoriteNodeV2';
import { computed } from 'mobx';
var styles = require('./FavoritesList.scss');
var FavoritesList = /** @class */ (function (_super) {
    tslib_1.__extends(FavoritesList, _super);
    function FavoritesList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderFindFavoritesComponents = function () {
            return [_this.renderAddNewFavoriteNode(), _this.renderFavoritesPicker()];
        };
        _this.renderAddNewFavoriteNode = function () {
            // Render a TreeNode with empty text if we're showing the picker.
            // This is because we want to preserve the same space as the original 'New favorite' node
            // so that the UI doesn't jump, and blank out the text so it doesn't temporarily show while the
            // picker animates in.
            if (getMailFavoritesStore().mailFavoritesViewState.shouldShowFindFavoritesPicker) {
                return null;
            }
            return (React.createElement(TreeNode, { displayName: strings.addFavoriteLabel, isCustomActionNode: true, isRootNode: false, key: 'newFavorite', onClick: _this.onNewFavoriteNodeClicked }));
        };
        _this.renderFavoritesPicker = function () {
            if (getMailFavoritesStore().mailFavoritesViewState.shouldShowFindFavoritesPicker) {
                return (React.createElement("div", { className: styles.favoritesPickerContainer },
                    React.createElement(FavoritesPicker, null)));
            }
            return null;
        };
        _this.onContextMenuDismissed = function () {
            hideFavoritesContextMenu();
        };
        return _this;
    }
    Object.defineProperty(FavoritesList.prototype, "favoritesStore", {
        get: function () {
            return getSharedFavoritesStore();
        },
        enumerable: true,
        configurable: true
    });
    FavoritesList.prototype.render = function () {
        return (React.createElement("div", null,
            isControlFeatureEnabled('tri-favorites-roaming')
                ? this.renderOutlookFavorites()
                : this.renderFavoriteNodes(),
            this.renderContextMenuIfOpen(),
            this.renderFindFavoritesComponents()));
    };
    FavoritesList.prototype.renderOutlookFavorites = function () {
        return this.favoritesStore.orderedOutlookFavoritesIds.map(function (favoriteId) {
            return React.createElement(FavoriteNodeV2, { key: favoriteId, favoriteId: favoriteId });
        });
    };
    FavoritesList.prototype.renderFavoriteNodes = function () {
        return this.favoritesStore.orderedFavoritesNodeIds.map(function (nodeId) {
            return React.createElement(FavoriteNode, { key: nodeId, favoriteId: nodeId });
        });
    };
    FavoritesList.prototype.renderContextMenuIfOpen = function () {
        var contextMenuState = getMailFavoritesStore().mailFavoritesViewState.contextMenuState;
        // Render the context menu if it is set to be visible
        if (!contextMenuState) {
            return null;
        }
        return (React.createElement(FavoriteNodeContextMenu, { anchorPoint: contextMenuState.anchor, nodeId: contextMenuState.nodeId, nodeType: contextMenuState.nodeType, folder: contextMenuState.folder, onDismiss: this.onContextMenuDismissed }));
    };
    FavoritesList.prototype.onNewFavoriteNodeClicked = function (evt) {
        showFindFavoritesPicker(true /* shouldShow */);
        logUsage(datapoints.FindFavoritesClicked.datapoint.name);
    };
    tslib_1.__decorate([
        computed
    ], FavoritesList.prototype, "favoritesStore", null);
    FavoritesList = tslib_1.__decorate([
        observer,
        logMountingPerformance('FavoriteFolderList')
    ], FavoritesList);
    return FavoritesList;
}(React.Component));
export default FavoritesList;
//# sourceMappingURL=FavoritesList.js.map